import { useState } from "react";
import First from "./First";
import Second from "./Second";
import FullModal from "../../Components/Modal/FullModal";
import Third from "./Third";
import { useModal } from "../../Sliders/Modal/ModalContext";

const ORANGE = "#FF6A1A";

const STEP_LABELS = ["Sign in", "Verify email", "Complete profile"];

const LoginProc = ({ setIsOpen, modalId }: any) => {
  const [currPage, setCurrPage] = useState(1);
  const { modalStates, hideModal } = useModal();
  const isOpen = modalStates[modalId]?.isOpen;

  const getPage = () => {
    switch (currPage) {
      case 1:
        return <First isOpen={isOpen} modalId={modalId} setCurrPage={setCurrPage} currPage={currPage} />;
      case 2:
        return <Second isOpen={isOpen} setCurrPage={setCurrPage} currPage={currPage} modalId={modalId} />;
      case 3:
        return <Third isOpen={isOpen} setCurrPage={setCurrPage} currPage={currPage} modalId={modalId} />;
      default:
        return <First isOpen={isOpen} setIsOpen={setIsOpen} setCurrPage={setCurrPage} currPage={currPage} />;
    }
  };

  if (!isOpen) return null;

  return (
    <FullModal isOpen={isOpen}>
      <div
        className="w-full h-full md:h-auto md:w-[95%] md:min-h-[520px] flex mx-auto md:rounded-[24px] overflow-y-auto md:overflow-hidden"
        style={{
          maxWidth: 780,
          boxShadow: "0 32px 80px rgba(0,0,0,.45)",
          background: "#FAF6F0",
        }}
      >
        {/* ── Left branding panel ── */}
        <div
          className="hidden md:flex flex-col"
          style={{
            width: "38%",
            flexShrink: 0,
            background: "linear-gradient(155deg,#1A2458 0%,#0B1030 100%)",
            padding: "36px 28px",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Dot grid */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              opacity: 0.14,
              backgroundImage: "radial-gradient(rgba(255,255,255,.6) 1px,transparent 1px)",
              backgroundSize: "28px 28px",
            }}
          />
          {/* Orange glow orb */}
          <div
            style={{
              position: "absolute",
              top: -70,
              right: -70,
              width: 220,
              height: 220,
              borderRadius: "50%",
              background: "radial-gradient(circle,rgba(255,106,26,.38),transparent 66%)",
              pointerEvents: "none",
            }}
          />

          {/* Brand */}
          <div style={{ position: "relative", zIndex: 1 }}>
            <div
              style={{
                fontFamily: '"Bricolage Grotesque", sans-serif',
                fontSize: 22,
                fontWeight: 800,
                color: "#fff",
                letterSpacing: -0.5,
                marginBottom: 10,
              }}
            >
              stavigo
            </div>
            <p style={{ fontSize: 13, color: "rgba(255,255,255,.5)", lineHeight: 1.7, maxWidth: 190 }}>
              Compare, book &amp; travel interstate across Nigeria — in minutes.
            </p>
          </div>

          {/* Mini route illustration */}
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              zIndex: 1,
            }}
          >
            <svg viewBox="0 0 200 130" width="200" height="130" style={{ overflow: "visible" }}>
              <path
                d="M20,100 C70,20 140,110 180,35"
                fill="none"
                stroke="rgba(255,255,255,.22)"
                strokeWidth="2"
                strokeDasharray="6 9"
                strokeLinecap="round"
              />
              {/* From pin */}
              <circle cx="20" cy="100" r="6" fill={ORANGE} />
              <circle cx="20" cy="100" r="12" fill="none" stroke={ORANGE} strokeOpacity=".28" strokeWidth="2" />
              {/* To pin */}
              <circle cx="180" cy="35" r="6" fill="rgba(255,255,255,.8)" />
              <circle cx="180" cy="35" r="12" fill="none" stroke="rgba(255,255,255,.28)" strokeWidth="2" />
              {/* Bus */}
              <g transform="translate(100,64) rotate(-14)">
                <rect x="-13" y="-9" width="26" height="18" rx="5" fill="#fff" />
                <rect x="-7" y="-5" width="15" height="6" rx="1.5" fill={ORANGE} />
                <circle cx="-6" cy="9" r="3" fill="#1A2458" />
                <circle cx="6" cy="9" r="3" fill="#1A2458" />
              </g>
            </svg>
          </div>

          {/* Step indicator */}
          <div style={{ position: "relative", zIndex: 1 }}>
            <div
              style={{
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: ".5px",
                textTransform: "uppercase",
                color: "rgba(255,255,255,.38)",
                marginBottom: 8,
              }}
            >
              {STEP_LABELS[currPage - 1]}
            </div>
            <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
              {[1, 2, 3].map((s) => (
                <div
                  key={s}
                  style={{
                    height: 6,
                    borderRadius: 3,
                    width: s === currPage ? 26 : 8,
                    background: s <= currPage ? ORANGE : "rgba(255,255,255,.18)",
                    transition: "all .3s",
                    flexShrink: 0,
                  }}
                />
              ))}
            </div>
          </div>
        </div>

        {/* ── Right form panel ── */}
        <div
          className="flex-1 flex flex-col px-5 pt-5 pb-8 md:px-8 md:pt-8 md:pb-7"
          style={{ position: "relative", minWidth: 0 }}
        >
          {/* Close button */}
          <button
            onClick={() => hideModal(modalId)}
            style={{
              position: "absolute",
              top: 16,
              right: 16,
              width: 34,
              height: 34,
              borderRadius: "50%",
              background: "rgba(16,21,53,.07)",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#6C7088",
              flexShrink: 0,
              transition: "background .15s",
            }}
            onMouseOver={(e) => ((e.currentTarget as HTMLElement).style.background = "rgba(16,21,53,.13)")}
            onMouseOut={(e) => ((e.currentTarget as HTMLElement).style.background = "rgba(16,21,53,.07)")}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>

          {/* Mobile brand header */}
          <div className="md:hidden" style={{ marginBottom: 28, paddingRight: 44 }}>
            <div
              style={{
                fontFamily: '"Bricolage Grotesque", sans-serif',
                fontSize: 22,
                fontWeight: 800,
                color: "#101535",
                letterSpacing: -0.5,
              }}
            >
              Stavigo<span style={{ color: ORANGE }}>.</span>com
            </div>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".5px", textTransform: "uppercase", color: "#9CA3AF", marginTop: 4 }}>
              Step {currPage} of 3 · {STEP_LABELS[currPage - 1]}
            </div>
          </div>

          {/* Mobile step bar */}
          <div className="flex md:hidden gap-1.5 mb-8">
            {[1, 2, 3].map((s) => (
              <div
                key={s}
                style={{
                  flex: 1,
                  height: 4,
                  borderRadius: 2,
                  background: s <= currPage ? ORANGE : "#E7E0D5",
                  transition: "background .3s",
                }}
              />
            ))}
          </div>

          {/* Step content */}
          <div className="flex-1 flex flex-col">
            {getPage()}
          </div>
        </div>
      </div>
    </FullModal>
  );
};

export default LoginProc;
